import { Input } from './style';

export function InputDate({ type, active = true, ...rest }) {
    return <Input type={type} active={active} {...rest} />
}